import {
    CompanyResponse,
    MarkResponse,
    ModelResponse,
    ModificationResponse,
    IRequestOptions,
    IRequestConfig,
    getConfigs,
    axios,
    basePath
} from './index.defs';

export class DictsService {
    /**
   *
   */
    static company(options: IRequestOptions = {}): Promise<CompanyResponse[]> {
        return new Promise((resolve, reject) => {
            const url = basePath + '/dict/company';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            const data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
   *
   */
    static mark(options: IRequestOptions = {}): Promise<MarkResponse[]> {
        return new Promise((resolve, reject) => {
            const url = basePath + '/dict/mark';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            const data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
   *
   */
    static model(
        params: {
            /**  */
            markId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ModelResponse[]> {
        return new Promise((resolve, reject) => {
            const url = basePath + '/dict/model';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { markId: params['markId'] };
            const data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
   *
   */
    static modifications(
        params: {
            /**  */
            modelId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ModificationResponse[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/dict/{modelId}/modifications';
            url = url.replace('{modelId}', params['modelId'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            const data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}
